import $ from "jquery";
import map from "lodash/map";
import Sortable from "sortablejs";

const updateOrder = function (postUrl, data) {
  $.ajax(postUrl, {
    method: "POST",
    data: data
  });
};

const makeSlideDeckSortable = function () {
  const postUrl = $(this).data("reorder-url");

  Sortable.create(this, {
    onUpdate: function (/**Event*/evt) {
      const data = map($(evt.item).closest(".slide-deck").find(".card"), function (e, i) {
        return {
          id: $(e).data("slide-id"),
          order: i
        };
      });

      updateOrder(postUrl, {
        data: data
      });
    }
  });
};

$(document).on("turbolinks:load", function () {
  const slideDeck = $(".slide-deck");
  if (slideDeck.length < 1) {
    return;
  }

  $(".slide-deck").each(makeSlideDeckSortable);
});
